import "./BannerLoadingIndicator.css";

const BannerLoadingIndicator = ({ children }) => (
	<span className="inline-flex flex-shrink-0 items-center justify-center px-2 py-1.5">
		<span className="inline-flex items-center gap-1" aria-hidden="true">
			<span className="books-banner-loading-dot h-1.5 w-1.5 rounded-full bg-white" />
			<span className="books-banner-loading-dot h-1.5 w-1.5 rounded-full bg-white" />
			<span className="books-banner-loading-dot h-1.5 w-1.5 rounded-full bg-white" />
		</span>
		<span className="sr-only">{children}</span>
	</span>
);

export default BannerLoadingIndicator;
